import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthenticatedLayout from './components/layout/AuthenticatedLayout';
import UserRights from './components/settings/UserRights';
import CalendarPage from './pages/CalendarPage';
import StatisticsPage from './pages/StatisticsPage';
import SkillsPage from './pages/SkillsPage';
import TechniciansPage from './pages/TechniciansPage';
import AbsencesPage from './pages/AbsencesPage';
import SettingsPage from './pages/SettingsPage';
import TeamsPage from './pages/TeamsPage';
import SupervisionPage from './pages/SupervisionPage';
import Login from './pages/Login';
import { useAuth } from './context/AuthContext';
import PermissionWarning from './components/common/PermissionWarning';

// Composant pour protéger les routes qui nécessitent une authentification
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AppRouter = () => {
  const { currentUser } = useAuth();

  // Si l'utilisateur est connecté et essaie d'accéder à /login, le rediriger vers /calendar
  if (currentUser && window.location.pathname === '/login') {
    return <Navigate to="/calendar" replace />;
  }

  return (
    <>
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={<Login />} />
      
      {/* Routes protégées */}
      <Route path="/" element={<AuthenticatedLayout />}>
        <Route path="settings/users" element={<UserRights />} />
        <Route path="planning" element={<CalendarPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="statistics" element={<StatisticsPage />} />
        <Route path="absences" element={<AbsencesPage />} />
        <Route path="technicians" element={<TechniciansPage />} />
        <Route path="skills" element={<SkillsPage />} />
        <Route path="teams" element={<TeamsPage />} />
        <Route path="supervision" element={<SupervisionPage />} />
        <Route path="settings" element={<SettingsPage />} />
        {/* Les routes par défaut doivent être à la fin */}
        <Route path="" element={<Navigate to="calendar" replace />} />
        <Route path="*" element={<Navigate to="calendar" replace />} />
      </Route>
    </Routes>
    <PermissionWarning />
    </>
  );
};

export default AppRouter; 